import icon from "../../assets/poe-plus.svg";
import type { Property } from "../../types";

export const poePorts: Property = {
  id: "poePorts",
  title: "poePorts.title",
  icon,
};
